// Web: the device's own UI face through the system stack (tokens.font.family). Nothing is fetched,
// so text never waits on a font file on a slow connection (PRODUCT.md, budget phones).
import { tokens } from "./tokens";

export function useAppFonts(): boolean {
  return true;
}

/** CSS font-family list: the system UI stack. */
export function appFontFamily(): string {
  return tokens.font.family;
}
